import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { MaintenanceProvider, useMaintenance } from './contexts/MaintenanceContext';
import { HelpCenterProvider } from './contexts/HelpCenterContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UserDetailPage from './pages/UserDetailPage';
import OrgChartPage from './pages/OrgChartPage';
import MaintenancePage from './pages/MaintenancePage';
import SSOPage from './pages/SSOPage';
import TutorialWindowPage from './pages/TutorialWindowPage';
import { Toaster } from 'sonner';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { token, loading, user } = useAuth();
  const { maintenanceStatus } = useMaintenance();
  
  if (loading || maintenanceStatus.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Chargement...</p>
        </div>
      </div>
    );
  }
  
  if (!token) return <Navigate to="/login" />;
  
  // Redirect non-admin users to maintenance page if maintenance is active
  if (maintenanceStatus.is_active && user && !user.is_admin) {
    return <Navigate to="/maintenance" replace />;
  }
  
  return children;
};

function AppContent() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sso" element={<SSOPage />} />
        <Route path="/maintenance" element={<MaintenancePage />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/:id" 
          element={
            <ProtectedRoute>
              <UserDetailPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/org-chart" 
          element={
            <ProtectedRoute>
              <OrgChartPage />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/aide/tutoriel/:tutorialId"
          element={
            <ProtectedRoute>
              <TutorialWindowPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <MaintenanceProvider>
          <HelpCenterProvider>
            <AppContent />
          </HelpCenterProvider>
        </MaintenanceProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;